/* eslint-disable react/no-unescaped-entities */
import React from 'react'

export const TermsApp = () => {
  return (
    <article className="terms-of-use">
      <h1>SUBSCRIPTION TERMS</h1>
      <h4>Effective as of August 14, 2025</h4>
      <section>
        <h2>ABOUT US</h2>

        <p className="mb-2.5">
          Our Platforms (“<strong>Platforms</strong>” means website(s), including but not limited
          to:
          <a href="https://clean-master.app/">https://clean-master.app/</a>, (the “
          <strong>Site</strong>”), mobile applications (means applications and games (each an “
          <strong>App</strong>”, collectively “<strong>Apps</strong>”)) and any related
          documentation, services; any images, logos, music, photographs and video content,
          software, designs, graphics, photos, images, illustrations, animations, videos, scripts,
          texts, music, sounds, voiceover, interactive features, wellness plans, and all other
          materials and content accessible within the Apps or Site that are incorporated into and
          form part of our Apps and etc. (“<strong>App Content</strong>”) are owned, managed and
          operated by the Company).
        </p>

        <p className="mb-2.5">Company shall mean:</p>

        <p className="mb-2.5">
          (1) <strong>Jomats FZCO</strong>, a United Arab Emirates company, is registered at Dubai
          Silicon Oasis, DDP, Building A2, Dubai, United Arab Emirates.
        </p>
        <p className="mb-2.5">
          This Policy forms an integral part of the Terms of Use and becomes binding on users upon
          their acceptance of the Terms of Use. Any translations of this Policy from the original
          English version are provided for convenience only. In the event of discrepancies between
          the English version and any translation, the English version shall take precedence and
          remain the sole legally binding version.
        </p>

        <p className="mb-2.5">
          <strong>Free or paid trial</strong>
        </p>
        <p className="mb-2.5">
          We may offer a free or paid trial subscription for the use of Platforms. Unless you cancel
          at least 24 hours before the end of the trial, you will be automatically charged a price
          indicated on the payment screen or/and Apple’s/Google’s or in our web page payment pop-up
          screen for a chosen subscription period. Please note that if a trial is offered, this will
          be explicitly stated on the price screen before the checkout. If this is not the case, you
          will purchase our subscription without a trial
        </p>
        <p className="mb-2.5">
          <strong>Subscription</strong>
        </p>
        <p className="mb-2.5">
          The subscription renews automatically for the same period at the end of each subscription
          period (each week, month, 6 months, year, or otherwise, depending on the option selected
          by you at the time of purchase) at the cost of the chosen plan. Your Account (if
          applicable) will be charged for the renewed subscription within 24 hours prior to the end
          of the current subscription. If you cancel the automatic renewal within the last 24 hours
          of the subscription, such cancellation will take effect at the end of the new
          subscription. We hereby notice that the cost of any subscription may vary.
        </p>
        <p className="mb-2.5">
          You may choose to add an additional features plan to your subscription. This additional
          feature plan will be merged with the main plan comprising the subscription.
        </p>
        <p className="mb-2.5">
          <strong>Payment method</strong>
        </p>
        <p className="mb-2.5">
          Payment methods for App Store or Google Play applicable in your region or credit card,
          PayPal, Apple Pay, Google Pay for our Site.
        </p>
        <p className="mb-2.5">
          Payment will be charged to the payment method you submitted at the time of purchase at
          confirmation of purchase (after you confirm by single-touch identification, facial
          recognition, or entering your payment method details on the web, or otherwise accepting
          subscription terms provided on the payment screen or on the pop-up screen provided by
          Apple/Google or on our web page) or after the end of the trial period. You authorize us to
          charge the applicable subscription fees to the payment method that you use.
        </p>
        <p className="mb-2.5">Receiving and processing payments</p>
        <p className="mb-2.5">
          The Company, in its exclusive discretion and prerogative, shall ascertain and designate
          the specific Account (if applicable) to be employed for the processing of any and all
          payments attributable to you, thereby retaining full authority and autonomy in the
          selection thereof.
        </p>
        <p className="mb-2.5">
          <strong>Refunds</strong>
        </p>
        <p className="mb-2.5">
          You purchased a subscription or enabled trial on the App Store: if you are eligible for a
          refund, you’ll have to request it directly from Apple. To request a refund, follow these
          instructions from the{' '}
          <a href="https://support.apple.com/en-us/118223">Apple support page.</a>
        </p>
        <p className="mb-2.5">
          You purchased a subscription or enabled trial on Google Play: if you are eligible for a
          refund, you’ll have to request it directly from Google. To request a refund, follow these
          instructions from{' '}
          <a href="https://support.google.com/googleplay/answer/2479637?hl=en">
            Google's support page.
          </a>
        </p>

        <p className="mb-2.5">
          You purchased a subscription or enabled trial on our Site: generally, the payments made to
          us are non-refundable.
        </p>
        <p className="mb-2.5">
          However, there are a few exceptions that can lead to a positive response to a refund
          request - see sections “Refund for subscriptions purchased on our Site“ and “Money-back
          policy for subscriptions purchased on our Site”.
        </p>
        <p className="mb-2.5">
          Please note that after your subscription period expires, we will not be able to refund you
          as the usage of the Platforms will be deemed executed in full, unless otherwise provided
          for by applicable law.
        </p>
        <p className="mb-2.5">Refund for subscriptions purchased on our Site.</p>
        <p className="mb-2.5">
          Below you will find the cases when a refund has a higher likelihood to be approved.
        </p>
        <p className="mb-2.5">
          If you possess certain refund rights under applicable laws. In this case, you should
          justify your refund request and submit all the relevant documentation that supports your
          right to receive the refund.
        </p>
        <p className="mb-2.5">
          In case of a confirmed bug that doesn’t allow you to use the application properly. To
          determine whether an issue you are experiencing is a bug indeed, you’ll need to provide
          all the necessary technical information to our Support Team and receive a confirmation
          from them.
        </p>
        <p className="mb-2.5">
          If you apply for a refund under our “Money-back policy for subscriptions purchased on our
          Site” and meet all the conditions set. Please, see the money-back policy rules below.
        </p>
        <p className="mb-2.5">Money-back policy for subscriptions purchased on our Site.</p>
        <p className="mb-2.5">
          If you purchased the Subscription directly on our Site and the money-back option was
          presented to you during the checkout, you are eligible to receive a refund if you did not
          get visible results with our App, provided that all of the following conditions are met:
        </p>
        <p className="mb-2.5">
          you contact us within 30 days after your initial purchase and before the end of your
          subscription period; and
        </p>
        <p className="mb-2.5">
          you have followed and actively used our App program (i) at least 14 consecutive days
          within the first subscription period after the purchase (for monthly and more lengthy
          subscription periods).
        </p>
        <p className="mb-2.5">
          Please note that after your subscription period expires, we will not be able to refund you
          as the usage of the Platforms will be deemed executed in full, unless otherwise provided
          for by applicable law.
        </p>
        <p className="mb-2.5">
          <strong>Dispute</strong>
        </p>
        <p className="mb-2.5">
          If, at any time, we record a decline, chargeback or other rejection of a charge of any
          payable fees on your Account (if applicable) (“<strong>Dispute</strong>”), this will be
          considered as a breach of your payment obligations hereunder, and your use of our
          Platforms may be automatically disabled or terminated.
        </p>
        <p className="mb-2.5">
          In the event a Dispute is performed, your Account (if applicable) may be blocked without
          the option to re-purchase or re-use it, and any data contained in such Account (if
          applicable) may be subject to cancellation.
        </p>
        <p className="mb-2.5">
          If you have any questions or concerns regarding a payment made to us, we encourage you to
          first contact our customer support team before submitting a Dispute or reversal of payment
          in order to prevent the purchased subscriptions from being cancelled and your Account (if
          applicable) from being suspended, and to avoid submitting an unwarranted or incorrect
          Dispute, which may result in you being liable for the applicable fees, in addition to
          repaying all fees applicable to the purchased subscriptions (and Dispute).
        </p>
        <p className="mb-2.5">
          <strong>Additional Subscription Terms</strong>
        </p>
        <p className="mb-2.5">
          If you choose the credit card payment method, we reserve the right to charge a validation
          fee in the amount of $0.50 (the price may slightly vary due to region and currency
          exchange rates) to make sure that your payment method is valid. Please note that an
          immediate refund will be issued for this charge to your payment method.
        </p>
        <p className="mb-2.5">
          In case when processing a payment, you don’t have enough funds to subscribe or bill for
          reporting month of subscription, we may apply a discount automatically as a one-time
          action. The discount does not apply to subsequent payments for auto-renewing
          subscriptions. The discount amount is determined at our discretion.
        </p>
        <p className="mb-2.5">
          <strong>Changes</strong>
        </p>
        <p className="mb-2.5">
          To the maximum extent permitted by applicable laws, we may change subscription fees at any
          time. We will give you advance notice of any such pricing changes by posting the new
          prices on or through the app or by emailing you notification, or in other prominent ways.
          If you do not wish to pay the new fees, you can cancel the applicable subscription prior
          to the change going into effect.
        </p>
        <p className="mb-2.5">
          If you have any questions in relation to the subscription terms, please contact us via{' '}
          <a href="mailto:support@clean-master.app">support@clean-master.app</a>.
        </p>
        <p className="mb-2.5">
          <strong>Model Withdrawal Form</strong>
        </p>

        <p className="mb-2.5">
          {' '}
          To: Jomats FZCO, a United Arab Emirates company, is registered at Dubai Silicon Oasis,
          DDP, Building A2, Dubai, United Arab Emirates, email: support@clean-master.app.
        </p>
        <p className="mb-2.5">
          I hereby give notice that I withdraw from my contract of the following service:
        </p>
        <p className="mb-2.5">Received on: [Date]</p>
        <p className="mb-2.5">Name: [Your Name]</p>
        <p className="mb-2.5">Address: [Your Address]</p>
        <p className="mb-2.5">Signature: (required only if sent by post mail) </p>
        <p className="mb-2.5">Date: [Date]</p>
      </section>
    </article>
  )
}
